import {connect} from "react-redux"
import State from "../../ducks/state"

export const mapStateToProps = (state: State) => {
    const {
        request: {siteUrl, cleanSiteUrl},
        settings: {isTpSuperLite, rememberSelectedDepartment},
        textAlignment,
    } = state

    return {
        url: isTpSuperLite ? cleanSiteUrl : siteUrl,
        textAlignment,
        text: {arrowIconUrlAltText: state.text.missionsCTA.arrowIconUrlAltText},
        rememberSelectedDepartment,
    }
}

export default connect(mapStateToProps)
